import React from 'react';
import { AccommodationListingDTO } from '@apps/accommodations/AccommodationsConsole.types';
import { useTranslation } from '@shared/core';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { useAccommodationsConsoleConfig } from '@apps/accommodations/AccommodationsConsoleConfigContext';

interface CouplesPickProps {
  listing: AccommodationListingDTO;
}

export const CouplesPick = ({ listing }: CouplesPickProps) => {
  const { t } = useTranslation('accommodationsConsole');
  const listingTrans = t('listingsPanel');
  const config = useAccommodationsConsoleConfig();

  const getCouplesPickText = () => {
    if (listing.type === 'roomBlock' && config.listingsPanel.listingEntry.roomBlockTag) {
      return config.listingsPanel.listingEntry.roomBlockTag;
    }
    if (listing.type === 'roomBlock') {
      return listingTrans.couplesPickRoomBlock();
    }
    return config.listingsPanel.listingEntry.shouldShowCouplePicksTag ? listingTrans.couplesPick() : null;
  };

  if (!getCouplesPickText()) {
    return null;
  }

  return (
    <Flex
      width="100%"
      justifyContent={{ _: 'flex-start', md: 'flex-end' }}
    >
      <Box
        paddingX={3}
        paddingY={1}
        borderRadius={2}
        color={'white'}
        backgroundColor={'mono14'}
      >
        <TextV2 typographyVariant="label2">{getCouplesPickText()}</TextV2>
      </Box>
    </Flex>
  );
};
